import React, { useState } from 'react';
import { Button, Accordion } from 'react-bootstrap';
import Modal from '../../../../../components/Modal';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';

const QuestionPropertiesModal = ({
  showQuestionPropertiesModal,
  setShowQuestionPropertiesModal,
  propertiesResult,
  setPropertiesResult,
  isSearchQuestion,
  handleSelectQuestion,
  questionModalDetails,
  isLoading
}) => {
  const [showStandardModal, setShowStandardModal] = useState(false);
  const [standardModalDetails, setStandardModalDetails] = useState({});

  const handleModalClose = () => {
    setPropertiesResult({});
    setShowQuestionPropertiesModal(false);
  };

  return (
    <>
      <Modal
        isOpen={showQuestionPropertiesModal}
        onClose={() => handleModalClose()}
        titleName='Question Properties'
        contentWidth='50%'>
        <table className='propertiesTable'>
          <>
            {isLoading &&
            <>
              {[...Array(4)].map((_, index) => (
                <tr key={index}>
                  {[...Array(1)].map((_, index) => (
                    <td key={`load-${index}`}>
                      <Skeleton />
                    </td>
                  ))}
                </tr>
              ))}
            </>
            }
            {!isLoading && propertiesResult?.data?.blockedText ?
              <>
                <div className='fw-semibold text-danger' dangerouslySetInnerHTML={{ __html: propertiesResult?.data?.blockedText }}></div>
              </>
              :
              <>
                {!isLoading && propertiesResult?.data && propertiesResult.data.questionType !== 'Skill' && (
                  <>
                    {propertiesResult.data.pcsInfo && <tr>
                      <td>My Content Set Info:</td>
                      <td>
                        <Accordion>
                          <Accordion.Header>My Content Set Info</Accordion.Header>
                          <Accordion.Body>
                            <table className='pcsInfoTable'>
                              {propertiesResult.data.pcsInfo.map((info, index) => {
                                return (
                                  <>
                                    <tr key={`setName_${index}`}>
                                      <td>Set Name:</td>
                                      <td>{info.setName}</td>
                                    </tr>
                                    <tr key={`ownedBy_${index}`}>
                                      <td>Owned By:</td>
                                      <td>{info.ownedBy}</td>
                                    </tr>
                                    <tr key={`questionNumber_${index}`}>
                                      <td>Question:</td>
                                      <td>{info.questionNumber}</td>
                                    </tr>
                                  </>
                                );
                              })}
  
                            </table>
                            <div className='d-flex flex-column'></div>
                          </Accordion.Body>
                        </Accordion>
                      </td>
                    </tr>}
                    {propertiesResult.data.examName && <tr>
                      <td>Exame Name:</td>
                      <td>{propertiesResult.data.examName}</td>
                    </tr>}
                    <tr>
                      <td>Course {propertiesResult.data.isTeacherQuestion ? '' : '=> Topic'}</td>
                      <td>
                        <div className='d-flex flex-column'>{propertiesResult.data.courseTopics?.map((course) => {
                          return (
                            <>
                              <span>{`${course.courseName} ${course.courseName != 'Teacher Question' ? '=>' : ''} ${course.courseName == 'Teacher Question' ? '' : course.topics?.join(', ')}`}</span>
                            </>
                          );
                        })}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Question Type:</td>
                      <td>{propertiesResult.data.questionType}</td>
                    </tr>
                    {isSearchQuestion &&
                    <>
                      {propertiesResult.data.standards?.length > 0 && <tr>
                        <td>{`Standard${propertiesResult.data.standards?.length == 1 ? '' : 's'}:`}</td>
                        <td>{propertiesResult.data.standards?.map((standard, index) => {
                          return (
                            <span key={`standard_${index}`} className='standardLink' onClick={() => { setStandardModalDetails(standard); setShowStandardModal(true); }}>{standard.standardNumber}</span>
                          );
                        })}</td>
                      </tr>}
                    </>
                    }
                    <tr>
                      <td>ID:</td>
                      <td>{propertiesResult.data.questionId}</td>
                    </tr>
                    {isSearchQuestion &&
                    <>
                      <tr>
                        <td>{`Attribute${propertiesResult.data.attributes?.length == 1 ? '' : 's'}:`}</td>
                        {propertiesResult.data.attributes?.length > 0 ? <td>{propertiesResult.data.attributes.join(', ')}</td> : <td className='noDataField'>None</td>}
                      </tr>
                      <tr>
                        <td>{`Tag${propertiesResult.data.tags?.length == 1 ? '' : 's'}:`}</td>
                        {propertiesResult.data.tags?.length > 0 ? <td>{propertiesResult.data.tags.join(', ')}</td> : <td className='noDataField'>None</td>}
                      </tr>
                    </>
                    }
                    {propertiesResult.data.courseTopics?.length > 0 && propertiesResult.data.courseTopics[0].courseName == 'Teacher Question' && <tr>
                      <td>Topics:</td>
                      {propertiesResult.data.courseTopics[0].topics?.length > 0 ?
                        <td className='d-flex flex-column'>
                          {propertiesResult.data.courseTopics[0].topics.map((topic, index) => {
                            return (
                              <span key={`topic_${index}`}>{topic}</span>
                            );
                          })}</td>
                        :
                        <td className='noDataField'>None</td>}
                    </tr>}
                    {propertiesResult.data.levels?.length > 0 && <tr>
                      <td>{`Level${propertiesResult.data.levels.length == 1 ? '' : 's'}:`}</td>
                      <td>{propertiesResult.data.levels.join(', ')}</td>
                    </tr>}
                    {propertiesResult.data.maxPoints !== 0 &&
                    <tr>
                      <td>Maximum Points:</td>
                      <td>{propertiesResult.data.maxPoints}</td>
                    </tr>
                    }
                    {propertiesResult.data.crType?.length > 0 &&
                    <tr>
                      <td>Type:</td>
                      <td>{propertiesResult.data.crType}</td>
                    </tr>
                    }
                    {propertiesResult.data.vocabulary?.length > 0 &&
                    <tr>
                      <td>Vocabulary:</td>
                      <td>{propertiesResult.data.vocabulary.join(', ')}</td>
                    </tr>}
                    {isSearchQuestion &&
                    <>
                      <tr>
                        <td>Hint:</td>
                        {propertiesResult.data.hint?.length > 0 ? <td dangerouslySetInnerHTML={{ __html: propertiesResult.data.hint }}></td> : <td className='noDataField'>None</td>}
                      </tr>
                      <tr>
                        <td>Reason:</td>
                        {propertiesResult.data.reason?.length > 0 ? <td dangerouslySetInnerHTML={{ __html: propertiesResult.data.reason }}></td> : <td className='noDataField'>None</td>}
                      </tr>
                    </>
                    }
                    {isSearchQuestion &&
                    <tr>
                      <td colSpan='2' className='text-end'>
                        <Button className='mt-3' variant='castleRed' disabled={questionModalDetails.inAssignment} onClick={(e) => { handleSelectQuestion(questionModalDetails, e); setShowQuestionPropertiesModal(false); }}>{`${questionModalDetails.isSelected ? 'Unselect Question' : 'Select Question'}`}</Button>
                      </td>
                    </tr>
                    }
                  </>
                )}
                {!isLoading && propertiesResult?.data && propertiesResult.data.questionType === 'Skill' &&
                <>
                  <tr>
                    <td>Course:</td>
                    <td>{propertiesResult.data.skillProperties.courseName}</td>
                  </tr>
                  <tr>
                    <td>ID:</td>
                    <td>{propertiesResult.data.skillProperties.questionId}</td>
                  </tr>
                  {propertiesResult.data.skillProperties.topic?.length > 0 &&
                    <tr>
                      <td>Topic:</td>
                      <td>{propertiesResult.data.skillProperties.topic}</td>
                    </tr>
                  }
                  {propertiesResult.data.skillProperties.skill?.length > 0 &&
                    <tr>
                      <td>Skill:</td>
                      <td>{propertiesResult.data.skillProperties.skill}</td>
                    </tr>
                  }
                  {propertiesResult.data.skillProperties.description?.length > 0 &&
                    <tr>
                      <td>Description:</td>
                      <td dangerouslySetInnerHTML={{ __html: propertiesResult.data.skillProperties.description }}></td>
                    </tr>
                  }
                  <tr>
                    <td>Level:</td>
                    <td>{propertiesResult.data.skillProperties.level}</td>
                  </tr>
                </>
                }
              </>
            }
          </>
        </table>

      </Modal>

      {/* Standards Modal */}
      <Modal
        isOpen={showStandardModal}
        onClose={() => setShowStandardModal(false)}
        titleName={`${standardModalDetails.stateName != 'National Standards' ? 'Standards for' : ''} ${standardModalDetails.stateName}`}
        contentWidth='40%'>
        <div className='d-flex flex-column'>
          <div className='fw-bold mb-4'>{standardModalDetails.groupName}</div>
          <div dangerouslySetInnerHTML={{ __html: standardModalDetails.description }}></div>
          <div className='d-flex flex-row justify-content-end mt-4'><Button variant='castleRed' className='w-25' onClick={() => setShowStandardModal(false)}>Ok</Button></div>
        </div>
      </Modal>
    </>

  );
};

QuestionPropertiesModal.propTypes = {
  showQuestionPropertiesModal: PropTypes.bool,
  setShowQuestionPropertiesModal: PropTypes.func,
  propertiesResult: PropTypes.object,
  setPropertiesResult: PropTypes.func,
  isSearchQuestion: PropTypes.bool,
  handleSelectQuestion: PropTypes.func,
  questionModalDetails: PropTypes.object,
  isLoading: PropTypes.bool
};

export default QuestionPropertiesModal;
